import { render, staticRenderFns } from "./ProfilesBar.vue?vue&type=template&id=05e00526&scoped=true"
import script from "./ProfilesBar.vue?vue&type=script&lang=js"
export * from "./ProfilesBar.vue?vue&type=script&lang=js"
import style0 from "./ProfilesBar.vue?vue&type=style&index=0&id=05e00526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e00526",
  null
  
)

export default component.exports